module.exports = __webpack_public_path__ + "static/media/automatic-migration-icon.bc0538f1.svg";